import { useT } from "../../../shared/i18n";
import { KeyValueList } from "../KeyValueList";
import { recordDetailItems } from "./recordItems";
import type { TraceRecord } from "./traceApi";

export function TraceRecordDetails({ record }: { record: TraceRecord }) {
  const t = useT();
  return <KeyValueList items={recordDetailItems(t, record)} />;
}
